<template>
  <div class="animate_animated animate__slideInRight">
    <div class="fixed w-full top-0 left-0 z-20">
      <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
         <div class="h-1 bg-gradient-to-r from-indigo-500 to-indigo-200"></div>
        <div class="flex items-center px-4 py-4">
          <div class="flex items-center w-full">
            <a @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
            <span class="text-base text-content font-medium ml-4">Agreement Details</span>
          </div>
        </div>

      </div>
    </div>

    <div class="pt-16 bg-gray-50 min-h-screen ">
      <el-tabs v-model="activeTab" class="tab-wrapper mt-2 px-4">
        <el-tab-pane label="Details" name="details">
          <div class="p-1 bg-gray-50 ">
            <h3 class="text-main font-semibold text-xs   mb-4">Basic Details</h3>
            <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">

              <div class="grid gap-3 grid-cols-2">
                <div class="col-span-full">
                  <span class="block text-xs text-slate-500 mb-2">Property</span>
                  <span class="block text-sm text-slate-800 ">{{ agreementDetails.property_name || '-' }}</span>
                </div>
              </div>
            </div>
             <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
            <div class="grid gap-3 grid-cols-2">
              <div>
                <span class="block text-xs text-slate-500 mb-2">Transaction Type</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.transaction_type || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Buyer</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.buyer_name || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Owner</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.owner || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Configuration</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.configuration || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Type</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.agreement_type_id || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Broker</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.broker || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Agreement From</span>
                <span class="block text-sm text-slate-800">{{ agreementDetails.agreement_date || '-' }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Agreement Till</span>
                <span class="flex items-center gap-2">
                <span class="block text-sm text-slate-800">{{ agreementDetails.agreement_till }} <span
                    class="bg-rose-100 text-rose-500 text-xxs  font-medium  rounded px-2 py-1 text-center inline-flex" style="line-height: 1;">{{ agreementDetails.days_left
                        > 0 ? agreementDetails.days_left + ' days left' : agreementDetails.days_left == 0 ? 'Today' :
                        'Expired'
                    }}
                  </span></span>
                  
                  
                </span>

              </div>
            </div>
            </div>
          </div>
          <div class="p-1 bg-gray-50 ">
            <h3 class="text-main font-semibold text-xs   mb-4">Financial Details</h3>
            <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4">
               <div class="grid gap-3 grid-cols-2">
              <div>
                <span class="block text-xs text-slate-500 mb-2">Price</span>
                <span class="block text-sm text-slate-800">Rs {{ $asINR(priceinLacs(agreementDetails.price)) }}</span>
              </div>
              <!-- <div>
								<span class="block text-xs text-slate-500 mb-2">Rent</span>
								<span class="block text-sm text-slate-800">10,000</span>
							</div> -->
              <div>
                <span class="block text-xs text-slate-500 mb-2">Buyer Brokerage</span>
                <span class="block text-sm text-slate-800">Rs
                  {{ $asINR(priceinLacs(agreementDetails.buyer_brokerage)) }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Seller Brokerage</span>
                <span class="block text-sm text-slate-800">Rs
                  {{ $asINR(priceinLacs(agreementDetails.seller_brokerage)) }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">Total Brokerage</span>
                <span class="block text-sm text-slate-800">Rs
                  {{ $asINR(priceinLacs(agreementDetails.total_brokerage)) }}</span>
              </div>
              <div>
                <span class="block text-xs text-slate-500 mb-2">CGST</span>
                <span class="block text-sm text-slate-800">Rs {{ $asINR(priceinLacs(agreementDetails.gst)) }}</span>
              </div>
            </div>
            </div>
           
          </div>
          <div class="p-1  bg-gray-50 ">
          <div class="flex items-center justify-center gap-3 mb-3">

              <button type="button" @click="deleteAgreement()"
                class="text-rose-500 text-xs  font-medium  flex items-center gap-2 flex-col justify-center rounded-xl bg-rose-50 shadow-sm ring-1 ring-rose-100 p-4 min-w-20 w-full"><Delete class="size-5" /> Delete</button>

              <router-link :to="{ name: 'EditAgreement', params: { uuid: this.$route.params.uuid } }"
                class="text-content text-xs font-medium text-opacity-50 flex items-center gap-2 flex-col justify-center rounded-xl bg-white/90 shadow-sm ring-1 ring-black/5 p-4 min-w-20 w-full">
                <Edit class="size-5" /> Edit 
              </router-link>

            </div>
        </div>

      
        </el-tab-pane>
        <el-tab-pane label="Collections" name="collections" class="">
           <div class="p-1 bg-gray-50 pb-32 ">
            <div class="rounded-2xl bg-white/90 shadow-sm ring-1 ring-black/5 p-5 mb-4" v-for="(c, key) in agreementDetails.collections" :key="key">
               <div class="grid gap-3 grid-cols-2">
                  <div>
                    <span class="block text-xs text-slate-500 mb-2">Amount</span>
                    <span class="block text-sm text-slate-800">{{ $asINR(priceinLacs(c.amount)) }}</span>
                  </div>
                  <div>
                    <span class="block text-xs text-slate-500 mb-2">Date</span>
                    <span class="block text-sm text-slate-800">{{ $dateFormat(c.created_at) }}</span>
                  </div>
                   <div>
                    <span class="block text-xs text-slate-500 mb-2">Type</span>
                    <span class="block text-sm text-slate-800">{{ c.payment_type }}</span>
                  </div>
                   <div>
                    <span class="block text-xs text-slate-500 mb-2">GST</span>
                    <span class="block text-sm text-slate-800">{{ c.status }}</span>
                  </div>
                   <div>
                    <span class="block text-xs text-slate-500 mb-2">Tax Amount</span>
                    <span class="block text-sm text-slate-800">{{ $asINR(priceinLacs(c.tax_amount)) }}</span>
                  </div>
                   <div>
                    <span class="block text-xs text-slate-500 mb-2">Mode</span>
                    <span class="block text-sm text-slate-800">{{ c.payment_mode }}</span>
                  </div>
               </div>
          
          </div>
           </div>
          

       
          <div class="fixed w-full bottom-0 left-0 bg-gray-50">
            <div class="flex items-center p-4 ">
              <div class="w-full">
                <router-link :to="{ name: 'Collection', params: { uuid: this.$route.params.uuid } }"
                  class="flex items-center w-full justify-center bg-primary text-white px-6 py-4 rounded-xl text-base font-medium">
                  Add Collection
                </router-link>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { numDifferentiation } from '@/assets/scripts/utility.js';
import Delete from '@/components/icons/Delete.vue';
import Edit from '@/components/icons/Edit.vue';
export default {
  components: {
    Delete,
    Edit
  },
  data() {
    return {
      agreementDetails: {},
      activeTab: 'details'
    }
  },
  created() {
    this.loadAgreementDetails()
  },
  methods: {
    deleteAgreement() {
      this.$swal.fire({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$axios
            .delete(`mobile_crm/agreements/${this.$route.params.uuid}/delete`)
            .then((res) => {
              this.$router.replace({ name: "Agreement" });
              this.$swal.fire({
                title: "Agreement Deleted!",
                icon: "success",
              });
            })
            .catch((err) => {
              if (err.response.status === 500) {
                this.$swal.fire({
                  title: "Server Error!",
                  icon: "error",
                });
              } else {
                this.$swal.fire({
                  title: "Error",
                  text: err.response.data.message,
                  icon: "error",
                });
              }
            });
        }
      });
    },
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    loadAgreementDetails() {
      this.$axios.get(`mobile_crm/agreements/${this.$route.params.uuid}`)
        .then((res) => {
          this.agreementDetails = res.data.agreement
        })
        .catch((err) => console.log(err));
    }
  }
}
</script>
<style scoped>
</style>